import { type LinearConfigurationUpdate } from "../../Linear/models";
import { prepareApiDataForResetOld, prepareGroupIdToDisplay } from "../../common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { prepareCommonLinearData, sendLinear } from "./sendLinearCommon";

export function sendLinearDetailsReset(carriageKmatId: string) {
  return (linearState: LinearConfiguratorState): Promise<LinearConfigurationUpdate> => {
    const data = prepareCommonLinearData(linearState);
    const resetData = prepareApiDataForResetOld(linearState);

    data.linearConfiguratorData.resetCarriageDetails = true;
    data.linearConfiguratorData.resetCarriageId = carriageKmatId;
    data.linearConfiguratorData.enableCarriageEdit = linearState.enableCarriageEdit;

    prepareGroupIdToDisplay(data);

    return sendLinear({
      ...data,
      ...resetData,
    });
  };
}
